/// <reference path="../../interfaces/lightsliderconfig.ts" />

module Elma.ViewModels {
    export class ProductPageViewModel extends Tapas.ViewModels.ProductPageViewModel {
        public lightSliderConfig: LightSliderConfig;
        public isReadMoreOpen = ko.observable(false);
        public isReadMoreRelevant = ko.observable(false);
        public loadedGallery = ko.observable(false);
        public readMoreBeforeText = ko.observable("");
        public readMoreAfterText = ko.observable("");
        public readMoreElementName = ko.observable(".main-product-description-full"); //SET WITH INITVALUE
        public descriptionHeight = ko.observable(0);
        public readMoreButtonText = ko.computed(() => {

            if (this.isReadMoreOpen()) {
                return this.readMoreAfterText();
            }
            else {
                return this.readMoreBeforeText();
            }

        });

        constructor() {
            super();

            this.calculateReadMoreVisibility(this.readMoreElementName());

            var itemsSlider: number = 1;
            var itemsAccessory: number = 1;
            var mediaMatchSupported: boolean = typeof window.matchMedia == "function";

            if (mediaMatchSupported) {

                if (window.matchMedia("(min-width:481px)")) {
                    itemsSlider = 3;
                    itemsAccessory = 3;
                }
            } else {
                if (window.innerWidth > 491) {
                    itemsSlider = 3;
                    itemsAccessory = 3;
                }
            }

            this.loadedGallery(true);

            this.lightSliderConfig = {
                gallery: true,
                galleryMargin: 32,
                item: 1,
                loop: true,
                auto: false,
                thumbItem: 5,
                thumbMargin: 30,
                slideMargin: 0,
                enableDrag: false,
                controls: false,
                currentPagerPosition: 'left',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            thumbItem: 2
                        },
                    }
                ],
                onSliderLoad: function(el) {
                    el.lightGallery({
                        thumbnail: false,
                    });
                }
            };
        }
        
        public gtmDataLayer() {
            console.log("Show productview");
            
            var productData = document.getElementById("product-view-details").dataset.productInfo;
            productData = JSON.parse(productData);
            var name = productData[0];
            var id = productData[1];
            var country = productData[2];
            var beforePrice = productData[3];
            var beforePriceVat = (beforePrice/100)*25;
            var beforePriceWithVat = beforePrice + beforePriceVat;
            var priceWithCurrency = productData[4];
            var brand = productData[5];
            var primaryGroup = productData[6];

            var priceSplit = priceWithCurrency.split(" ");
            var priceWithoutCurrency = priceSplit[0];
            var currency = priceSplit[1];
            var eventType = "view_item";
            
            console.log("Productview", name, id, country, beforePriceWithVat, priceWithoutCurrency, brand, primaryGroup);

            var windowAny = (window as any);
            windowAny.dataLayer.push({ ecommerce: null });
            windowAny.dataLayer.push({
                event: eventType,
                ecommerce: {
                    items: [{
                        item_name: name,
                        item_id: id,
                        affiliation: country,
                        discount: beforePriceWithVat,
                        price: priceWithoutCurrency,
                        item_brand: brand,
                        item_category: primaryGroup,
                        //item_list_name: '[item list name]',
                        //item_list_id: '[item list id]',
                        //item_variant: '[item variant]',
                        //location_id: '[location_id]',
                        //index: '[index number]',
                        quantity: '1',
                        currency: currency
                    }]
                }
            });
        }

        public calculateReadMoreVisibility(elementName) {

            var element = $(elementName);
            var height = element.height();

            if (height > 75) {

                this.descriptionHeight(height);
                element.height(75);
                this.isReadMoreRelevant(true);

            }

        }

        public toggleReadMore() {

            var element = $(this.readMoreElementName());
            this.isReadMoreOpen(!this.isReadMoreOpen());

            if (this.isReadMoreOpen()) {

                element.height(this.descriptionHeight());


            }
            else {

                element.height(75);

            }

        }

        public zoomClickHandler = () => {
            $('.lslide.active').trigger('click');
        }

    }
}